<template>
  <div class="container">
    <my-nav-ui :idx="2"></my-nav-ui>
    <div class="center">
      <div class="left">
        <div class="center-top">
          <div class="top-title">
            <div v-if="regionType == 0">全国所有数据</div>
            <div v-else-if="regionType == 1">全省所有数据</div>
            <div v-else-if="regionType == 2">全市所有数据</div>
            <div v-else-if="regionType == 3 && cityName.indexOf('区') != -1">
              全区所有数据
            </div>
            <div v-else-if="regionType == 3 && cityName.indexOf('县') != -1">
              全县所有数据
            </div>
            <div v-else-if="regionType == 3 && cityName.indexOf('市') != -1">
              全市所有数据
            </div>
            <div v-else>全区所有数据</div>
          </div>
          <div class="top-d1">
            <span>
              电梯总数量
              <i>{{ ViewData.deviceTotal }}</i
              >台
            </span>
          </div>
        </div>
        <div class="center-down">
          <div class="center-down-item">
            <ul>
              <li class="li-text">物业公司</li>
              <li class="li-val">
                <span class="li-val-color-2">{{
                  ViewData.manageCountByFixing
                }}</span
                >家
              </li>
            </ul>
          </div>
          <div class="center-down-item">
            <ul>
              <li class="li-text">维保公司</li>
              <li class="li-val">
                <span class="li-val-color-3">{{
                  ViewData.maintainCountByFixing
                }}</span
                >家
              </li>
            </ul>
          </div>
          <div class="center-down-item">
            <ul>
              <li class="li-text">年检过期</li>
              <li class="li-val">
                <span class="li-val-color-4">{{
                  ViewData.annualTotalFixingCount
                }}</span
                >台
              </li>
            </ul>
          </div>
          <div class="center-down-item">
            <ul>
              <li class="li-text">维保过期</li>
              <li class="li-val">
                <span class="li-val-color-4">{{
                  ViewData.maintainTotalFixingCount
                }}</span
                >台
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="center-top">
          <div class="top-title">
            <div>安装设备数据</div>
          </div>
          <div class="top-d1">
            <span>
              终端总数量
              <i>{{ ViewData.gatewayTotal }}</i
              >台
            </span>
          </div>
        </div>
        <div class="center-down">
          <div class="center-down-item">
            <ul>
              <li class="li-text">物业公司</li>
              <li class="li-val">
                <span class="li-val-color-2">{{
                  ViewData.manageCountByGateway
                }}</span
                >家
              </li>
            </ul>
          </div>
          <div class="center-down-item">
            <ul>
              <li class="li-text">维保公司</li>
              <li class="li-val">
                <span class="li-val-color-3">{{
                  ViewData.maintainCountByGateway
                }}</span
                >家
              </li>
            </ul>
          </div>
          <div class="center-down-item">
            <ul>
              <li class="li-text">年检过期</li>
              <li class="li-val">
                <span class="li-val-color-4">{{
                  ViewData.annualTotalGatewayCount
                }}</span
                >台
              </li>
            </ul>
          </div>
          <div class="center-down-item">
            <ul>
              <li class="li-text">维保过期</li>
              <li class="li-val">
                <span class="li-val-color-4">{{
                  ViewData.maintainTotalGatewayCount
                }}</span
                >台
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="left">
        <div class="item">
          <div class="item-left">
            <div class="bottom-left-bg-1">
              <ul>
                <li>人工报警</li>
                <li>{{ warningData.total }}起</li>
              </ul>
            </div>
          </div>
          <div class="item-right">
            <div class="item-right-box">
              <div class="item-right-text">
                <ul>
                  <li>累计</li>
                  <li><i class="bottom-left-color-1">人工报警</i>完成率</li>
                  <li>
                    <i class="bottom-left-color-1"
                      >{{ warningData.scale.toFixed(0) }}%</i
                    >
                  </li>
                </ul>
              </div>
              <div class="item-right-charts-info">
                <div class="item-right-charts">
                  <div id="charts21" class="charts"></div>
                </div>
                <div class="item-right-info">
                  <ul>
                    <li>剩余</li>
                    <li>
                      <i class="bottom-left-color-1">{{
                        warningData.total - warningData.finish
                      }}</i
                      >起
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="item-left">
            <div class="bottom-left-bg-2">
              <ul>
                <li>故障报警</li>
                <li>{{ tipData.total }}起</li>
              </ul>
            </div>
          </div>
          <div class="item-right">
            <div class="item-right-box">
              <div class="item-right-text">
                <ul>
                  <li>累计</li>
                  <li><i class="bottom-left-color-2">故障报警</i>完成率</li>
                  <li>
                    <i class="bottom-left-color-2"
                      >{{ tipData.scale.toFixed(0) }}%</i
                    >
                  </li>
                </ul>
              </div>
              <div class="item-right-charts-info">
                <div class="item-right-charts">
                  <div id="charts22" class="charts"></div>
                </div>
                <div class="item-right-info">
                  <ul>
                    <li>剩余</li>
                    <li>
                      <i class="bottom-left-color-2">{{
                        tipData.total - tipData.finish
                      }}</i
                      >起
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="item-left">
            <div class="bottom-left-bg-3">
              <ul>
                <li>投诉建议</li>
                <li>{{ advData.total }}起</li>
              </ul>
            </div>
          </div>
          <div class="item-right">
            <div class="item-right-box">
              <div class="item-right-text">
                <ul>
                  <li>累计</li>
                  <li><i class="bottom-left-color-3">投诉建议</i>完成率</li>
                  <li>
                    <i class="bottom-left-color-3"
                      >{{ advData.scale.toFixed(0) }}%</i
                    >
                  </li>
                </ul>
              </div>
              <div class="item-right-charts-info">
                <div class="item-right-charts">
                  <div id="charts23" class="charts"></div>
                </div>
                <div class="item-right-info">
                  <ul>
                    <li>剩余</li>
                    <li>
                      <i class="bottom-left-color-3">{{
                        advData.total - advData.finish
                      }}</i
                      >起
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="middle"
        v-loading="loading"
        element-loading-spinner="el-icon-loading"
        element-loading-background="#121D49"
      >
        <div class="title">
          今日报警投诉物业单位统计
          <span style="color: #ff6666">(TOP10)</span>
        </div>
        <div class="sub-title">
          <div>
            <span>人工报警</span>
            <span style="background: #ff6666">{{ TotalData.t1 }}</span>
          </div>
          <div>
            <span>故障报警</span>
            <span style="background: #ffca6c">{{ TotalData.t2 }}</span>
          </div>
          <div>
            <span>投诉建议</span>
            <span style="background: #468fb7">{{ TotalData.t3 }}</span>
          </div>
        </div>
        <div class="list">
          <div
            class="item"
            v-for="item in manageAlarmRankingsList"
            :key="item.groupName"
          >
            <label>{{ !item.groupName ? '未关联物业' : item.groupName }}</label>
            <div>
              <span style="background: #ff6666">{{ item.totalCount }}</span>
              <span style="background: #ffca6c">{{ item.faultQuantity }}</span>
              <span style="background: #468fb7">0</span>
            </div>
          </div>
        </div>
      </div>
      <div class="middle">
        <div class="title">
          今日报警投诉维保单位统计
          <span style="color: #ff6666">(TOP10)</span>
        </div>
        <div class="sub-title">
          <div>
            <span>人工报警</span>
            <span style="background: #ff6666">{{ TotalData.t4 }}</span>
          </div>
          <div>
            <span>故障报警</span>
            <span style="background: #ffca6c">{{ TotalData.t5 }}</span>
          </div>
          <div>
            <span>投诉建议</span>
            <span style="background: #468fb7">{{ TotalData.t6 }}</span>
          </div>
        </div>
        <div class="list">
          <div
            class="item"
            v-for="item in maintainAlarmRankingsList"
            :key="item.groupName"
          >
            <label>{{ !item.groupName ? '未关联物业' : item.groupName }}</label>
            <div>
              <span style="background: #ff6666">{{ item.totalCount }}</span>
              <span style="background: #ffca6c">{{ item.faultQuantity }}</span>
              <span style="background: #468fb7">0</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GLOBAL from '@/api/global_variable'
import chartsView1 from '@/api/charts_view1'
import { setTimeout } from 'timers'
export default {
  name: 'EchartsView2',
  data() {
    return {
      // deviceTotal: GLOBAL.eTotal,
      loading: true,
      charts1: null,
      charts2: null,
      charts3: null,
      data1: {
        d1: 0,
        d2: 0,
        d3: 0,
        d4: 0,
        d5: 0,
      },
      data2: {
        d1: 0,
        d2: 0,
        d3: 0,
        d4: 0,
        d5: 0,
      },
      // 工人报警
      warningData: {
        total: 0,
        finish: 0,
        scale: 100,
      },
      // 异常提醒
      tipData: {
        total: 0,
        finish: 0,
        scale: 100,
      },
      // 投拆建议
      advData: {
        total: 0,
        finish: 0,
        scale: 100,
      },
      ViewData: {
        deviceTotal: 0, // 全市电梯总数
        gatewayTotal: 0, // 全市终端总数
        manageCountByFixing: 0, // 全市物业单位
        maintainCountByFixing: 0, // 全市维保单位
        manageCountByGateway: 0, // 全市终端物业单位
        maintainCountByGateway: 0, // 全市终端维保单位
        annualTotalFixingCount: 0, // 全市年检过期数
        annualTotalGatewayCount: 0, // 全市年检终端过期数
        maintainTotalFixingCount: 0, // 全市维保终端过期数
        maintainTotalGatewayCount: 0, // 全市维保终端过期数
      },
      TotalData: { t1: 0, t2: 0, t3: 0, t4: 0, t5: 0, t6: 0 },
      manageAlarmRankingsList: [],
      manageFaultRankingsList: [],
      manageComplaintList: [],
      managerankTotalList: [],
      maintainAlarmRankingsList: [],
      maintainFaultRankingsList: [],
      maintainComplaintList: [],
      maintainrankTotalList: [],
      cityName: '',
      regionType: 0,
      timerId: 0
    }
  },
  mounted() {
    if (!GLOBAL.isLogin()) {
      this.$router.push({ path: '/login' })
    }
    GLOBAL.curPage = 2
    this.loading = false
    // this.ViewData.TodaySituation.AccumulativeStatistics.ProcessedStatusQuantity.AlarmQuantity = 14

    var that = this
    setTimeout(function () {
      that.charts1 = that.$echarts.init(document.getElementById('charts21'))
      that.charts1.setOption(
        chartsView1.chartsProOption(
          that.warningData.scale.toFixed(0),
          '#ff6666',
          that.warningData.finish
        )
      )

      that.charts2 = that.$echarts.init(document.getElementById('charts22'))
      that.charts2.setOption(
        chartsView1.chartsProOption(
          that.tipData.scale.toFixed(0),
          '#ffca6c',
          that.tipData.finish
        )
      )

      that.charts3 = that.$echarts.init(document.getElementById('charts23'))
      that.charts3.setOption(
        chartsView1.chartsProOption(
          that.advData.scale.toFixed(0),
          '#468fb7',
          that.advData.finish
        )
      )
    }, 1000)
  },
  created() {
    this.drawView1Charts1()
    this.drawView1Charts2()
    this.drawView1Charts3()
    this.drawView1Charts4()
    this.drawView1Charts5()
    this.drawView1Charts6()
    this.drawView1Charts7()

    var that = this;
    this.timerId = setInterval(function(){
      that.drawView1Charts1()
      that.drawView1Charts2()
      that.drawView1Charts3()
      that.drawView1Charts4()
      that.drawView1Charts5()
      that.drawView1Charts6()
      that.drawView1Charts7()
    }, 5000);
    
    this.cityName = sessionStorage.getItem('cityName')
    this.regionType = sessionStorage.getItem('regionType')
    console.log(this.regionType)
    console.log(this.timerId)
  },
  beforeDestroy() {
    console.log('beforeDestroy:'+this.timerId)
    clearInterval(this.timerId);
  },
  methods: {
    // 全市电梯总数 终端总数
    drawView1Charts1() {
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId'),
        },
        methods: 'get',
        url: process.env.API_ROOT + '/Visual/fixing/count',
      }).then((res) => {
        // this.cityName = sessionStorage.getItem('cityName')
        // this.ViewData.deviceTotal = GLOBAL.eTotal
        this.ViewData.deviceTotal = res.data.result
        // GLOBAL.totalData.forEach(item => {
        //   if (item.name == this.cityName) {
        //     this.ViewData.deviceTotal = item.size
        //   }
        // })
      })
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId'),
        },
        methods: 'get',
        url: process.env.API_ROOT + '/Visual/gateway/count',
      }).then((res) => {
        // if (this.cityName == '临泉县') {
        //   this.ViewData.gatewayTotal = 1214
        // } else {
        this.ViewData.gatewayTotal = res.data.result
        // }
      })
    },
    // 全市物业 维保单位   全市终端 物业 维保数
    drawView1Charts2() {
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId'),
        },
        methods: 'get',
        url: process.env.API_ROOT + '/Visual/unit/byfixing',
      }).then((res) => {
        // if (this.cityName == '临泉县') {
        //   this.ViewData.manageCountByFixing = 45
        //   this.ViewData.maintainCountByFixing = 27
        //   this.ViewData.manageCountByGateway =
        //     res.data.result.manageCountByGateway
        //   this.ViewData.maintainCountByGateway =
        //     res.data.result.maintainCountByGateway
        // } else {
        this.ViewData.manageCountByFixing = res.data.result.manageCountByFixing
        this.ViewData.maintainCountByFixing =
          res.data.result.maintainCountByFixing
        this.ViewData.manageCountByGateway =
          res.data.result.manageCountByGateway
        this.ViewData.maintainCountByGateway =
          res.data.result.maintainCountByGateway
        // }
      })
    },
    // 年检过期设备数
    drawView1Charts3() {
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId'),
        },
        methods: 'get',
        url: process.env.API_ROOT + '/Visual/annual/overdue',
      }).then((res) => {
        this.ViewData.annualTotalFixingCount = res.data.result.totalFixingCount
        this.ViewData.annualTotalGatewayCount =
          res.data.result.totalGatewayCount
      })
    },
    // 维保过期数
    drawView1Charts4() {
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId'),
        },
        methods: 'get',
        url: process.env.API_ROOT + '/Visual/maintain/overdue',
      }).then((res) => {
        this.ViewData.maintainTotalFixingCount =
          res.data.result.totalFixingCount
        this.ViewData.maintainTotalGatewayCount =
          res.data.result.totalGatewayCount
      })
    },
    // 故障
    drawView1Charts5() {
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId'),
        },
        methods: 'get',
        url: process.env.API_ROOT + '/Visual/fault/today',
      }).then((res) => {
        this.warningData.total = res.data.result.totalAlarmCount
        this.warningData.finish = res.data.result.totalAlarmHandleCount
        this.warningData.scale =
          this.warningData.total === 0
            ? 100
            : (Number(this.warningData.finish) /
                Number(this.warningData.total)) *
              100
      })
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId'),
        },
        methods: 'get',
        url: process.env.API_ROOT + '/Visual/fault/today',
      }).then((res) => {
        this.tipData.total = res.data.result.totalFaultCount
        this.tipData.finish = res.data.result.totalFaultHandleCount
        this.tipData.scale =
          this.tipData.total === 0
            ? 100
            : (Number(this.tipData.finish) / Number(this.tipData.total)) * 100
      })
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId'),
        },
        methods: 'get',
        url: process.env.API_ROOT + '/Visual/complaint/year',
      }).then((res) => {
        this.advData.total = res.data.result.totalCount
        this.advData.finish = res.data.result.handleCount
        this.advData.scale =
          this.advData.total === 0
            ? 100
            : (Number(this.advData.finish) / Number(this.advData.total)) * 100
      })
    },
    // 报警投诉物业单位统计
    drawView1Charts6() {
      // this.axios({
      //   headers: {
      //     orgId: sessionStorage.getItem('orgId')
      //   },
      //   methods: 'get',
      //   url: process.env.API_ROOT + '/Visual/fault/today'
      // }).then(res=>{
      //   console.log(res)
      // })

      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId'),
        },
        methods: 'get',
        url: process.env.API_ROOT + '/Visual/unit/managerank/byfault',
      }).then((res) => {
        // this.TotalData.t1 = res.data.result.alarmRankings.length
        // this.TotalData.t2 = res.data.result.faultRankings.length
        this.manageAlarmRankingsList = res.data.result.alarmRankings
        this.manageFaultRankingsList = res.data.result.faultRankings
        var t1Count = 0;
        this.manageAlarmRankingsList.forEach((item) => {
          t1Count += item.totalCount
        })
        this.TotalData.t1 = t1Count

        var t2Count = 0
        this.manageFaultRankingsList.forEach((item) => {
          t2Count += item.totalCount
        })
        this.TotalData.t2 = t2Count

        this.axios({
          headers: {
            orgId: sessionStorage.getItem('orgId'),
          },
          methods: 'get',
          url: process.env.API_ROOT + '/Visual/unit/managerank/bycomplaint',
        }).then((res) => {
          // this.TotalData.t3 = res.data.result.length
          this.manageComplaintList = res.data.result
        })
        this.manageFaultRankingsList.forEach((faultItem) => {
          this.manageAlarmRankingsList.forEach((alarmItem) => {
            if (faultItem.groupId === alarmItem.groupId) {
              alarmItem.faultQuantity = faultItem.totalCount
            }
          })
        })
      })
    },
    // 报警投诉维保单位统计
    drawView1Charts7() {
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId'),
        },
        methods: 'get',
        url: process.env.API_ROOT + '/Visual/unit/maintainrank/byfault',
      }).then((res) => {
        // this.TotalData.t4 = res.data.result.alarmRankings.length
        // this.TotalData.t5 = res.data.result.faultRankings.length
        this.maintainAlarmRankingsList = res.data.result.alarmRankings
        this.maintainFaultRankingsList = res.data.result.faultRankings
        this.maintainAlarmRankingsList.forEach((item) => {
          this.TotalData.t4 += item.totalCount
        })
        this.maintainFaultRankingsList.forEach((item) => {
          this.TotalData.t5 += item.totalCount
        })

        this.axios({
          headers: {
            orgId: sessionStorage.getItem('orgId'),
          },
          methods: 'get',
          url: process.env.API_ROOT + '/Visual/unit/maintainrank/bycomplaint',
        }).then((res) => {
          // this.TotalData.t6 = res.data.result.length
          this.maintainComplaintList = res.data.result
        })
        this.maintainFaultRankingsList.forEach((faultItem) => {
          this.maintainAlarmRankingsList.forEach((alarmItem) => {
            if (faultItem.groupId === alarmItem.groupId) {
              alarmItem.faultQuantity = faultItem.totalCount
            }
          })
        })
      })
    },
    numFormat: function (number) {
      var _number = parseFloat(number).toFixed(2) + ''
      var _suffix = ''
      if (_number.indexOf('.') > 0) {
        _suffix = _number.split('.')[1]
        if (_suffix === '00') {
          return _number.split('.')[0]
        }
      }
      return _number
    },
    getRate1: function (obj) {
      if (obj.ProcessedStatusQuantity.AlarmQuantity === 0) {
        return 100
      } else {
        if (obj.ProcessedStatusQuantity.AlarmQuantity === 0) {
          return (1 / obj.StatusQuantity.AlarmQuantity) * 100
        } else {
          return (
            (obj.ProcessedStatusQuantity.AlarmQuantity /
              obj.StatusQuantity.AlarmQuantity) *
            100
          ).toFixed(2)
        }
      }
    },
    getRate2: function (obj) {
      if (obj.ProcessedStatusQuantity.FaultQuantity === 0) {
        return 100
      } else {
        if (obj.ProcessedStatusQuantity.FaultQuantity === 0) {
          return (1 / obj.StatusQuantity.FaultQuantity) * 100
        } else {
          return (
            (obj.ProcessedStatusQuantity.FaultQuantity /
              obj.StatusQuantity.FaultQuantity) *
            100
          ).toFixed(2)
        }
      }
    },
    getRate3: function (obj) {
      if (obj.ProcessedStatusQuantity.ComplaintQuantity === 0) {
        return 100
      } else {
        if (obj.ProcessedStatusQuantity.ComplaintQuantity === 0) {
          return (1 / obj.StatusQuantity.ComplaintQuantity) * 100
        } else {
          return (
            (obj.ProcessedStatusQuantity.ComplaintQuantity /
              obj.StatusQuantity.ComplaintQuantity) *
            100
          ).toFixed(2)
        }
      }
    },
    getWidth1: function (obj) {
      var bfb = this.getRate1(obj)
      // console.log('width:' + bfb + '%')
      return 'width:' + bfb + '%'
    },
    getWidth2: function (obj) {
      var bfb = this.getRate2(obj)
      // console.log('width:' + bfb + '%')
      return 'width:' + bfb + '%'
    },
    getWidth3: function (obj) {
      var bfb = this.getRate3(obj)
      // console.log('width:' + bfb + '%')
      return 'width:' + bfb + '%'
    },
  },
}
</script>
<style lang="css" rel="stylesheet/scss"  scoped>
ul {
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0;
}
li {
  list-style: none;
}
.li-text {
  height: 40px;
  line-height: 40px;
  font-size: 20px;
  color: #a7c6d6;
  letter-spacing: 2px;
}
.li-val {
  height: 60px;
  line-height: 60px;
  font-size: 20px;
  color: #a7c6d6;
  letter-spacing: 2px;
}
.li-val > span {
  font-size: 40px;
}

.li-val-color-1 {
  color: #3ef75c;
}
.li-val-color-2 {
  color: #ffce00;
}
.li-val-color-3 {
  color: #ff9100;
}
.li-val-color-4 {
  color: #fc0000;
}

.container {
  width: 100%;
  height: calc(100% - 40px);
  background: #0b133f;
}
.center {
  height: 230px;
  width: 98%;
  margin: 0 auto;
  margin-top: 10px;
}
.center .title {
  letter-spacing: 2px;
  display: block;
  font-size: 18px;
  color: #fff;
  width: 100%;
  height: 30px;
  line-height: 30px;
  text-align: left;
}
.center .line:last-child {
  border-bottom: 2px solid #a7c6d6;
}
/* */
.center .left {
  width: calc(50% - 5px);
  width: -webkit-calc(50% - 5px);
  width: -moz-calc(50% - 5px);
  height: 100%;
  float: left;
  background: #121d49;
  border-radius: 6px;
}

.center-top {
  width: 94%;
  height: 45%;
  margin: 0 auto;
}

.center-top .top-title {
  width: 50%;
  height: 100%;
  float: left;
}
.center-top .top-title > div {
  display: flex;
  text-align: left;
  color: #73ffff;
  font-size: 34px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 100px;
  line-height: 100px;
}

.center-top .top-d1 {
  width: 50%;
  height: 100%;
  float: left;
}

.center-top .top-d1 > span {
  width: 100%;
  text-align: left;
  height: 100px;
  line-height: 100px;
  font-size: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  color: #a7c6d6;
  letter-spacing: 2px;
}

.center-top .top-d1 > span > i {
  font-style: normal;
  display: inline;
  padding: 0px 1px 0px 1px;
  color: #3ef75c;
}

.center-down {
  width: 94%;
  height: 55%;
  margin: 0 auto;
}

.center-down .center-down-item {
  width: 25%;
  height: 100%;
  float: left;
}

.center-down-item > ul > li {
  text-align: left;
}

.center-top-left {
  width: 45%;
  height: 170px;
  float: left;
}

.center-top-left .top-left-top {
  width: calc(100% - 15px);
  width: -webkit-calc(100% - 15px);
  width: -moz-calc(100% - 15px);
  height: 76px;
  line-height: 76px;
  margin-bottom: 10px;
  color: #73ffff;
  font-size: 30px;
  font-weight: bold;
  border: 2px solid #2b72d8;
  border-radius: 4px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.center-top-left .top-left-down {
  width: 100%;
  height: 80px;
}

.center-top-left .top-left-down > div {
  width: 65%;
  float: right;
  height: 100%;
  border-radius: 3px 0px 0px 3px;
  border: 1px solid #2b72d8;
  border-right: 0px;
}

.center-top-left .top-left-down > div > ul > li {
  width: 100%;
  text-align: center;
}

.center-top-right {
  width: 55%;
  height: 100%;
  float: right;
}
.center-top-right > div {
  width: 100%;
}
.center-top-right .top-right-top {
  width: calc(100% - 2px);
  width: -webkit-calc(100% - 2px);
  width: -moz-calc(100% - 2px);
  height: 80px;
  margin-top: 10px;
  border-radius: 3px 3px 0px 0px;
  border: 1px solid #2b72d8;
  border-bottom: 0px;
}

.center-top-right .top-right-top .top-right-top-left {
  width: 48%;
  float: left;
  text-align: center;
}
.center-top-right .top-right-top .top-right-top-right {
  width: 48%;
  float: right;
  text-align: center;
}
.center-top-right .top-right-down {
  width: calc(100% - 2px);
  width: -webkit-calc(100% - 2px);
  width: -moz-calc(100% - 2px);
  height: 80px;
  border: 1px solid #2b72d8;
  border-radius: 0px 0px 3px 0px;
  border-top: 0px;
  border-left: 1px solid transparent;
}

.center-top-right .top-right-down .top-right-down-item {
  width: 48%;
  float: left;
  text-align: center;
}
.center-top-right .top-right-down .top-right-down-right {
  width: 48%;
  float: right;
  text-align: center;
}

.center .right {
  width: calc(50% - 5px);
  width: -webkit-calc(50% - 5px);
  width: -moz-calc(50% - 5px);
  height: 100%;
  float: right;
  background: #121d49;
  border-radius: 6px;
}
/* */

.center .line {
  display: flex;
  height: calc(50% - 15px);
  width: 100%;
}
.center .line .item {
  width: 25%;
  color: #a7c6d6;
  font-size: 16px;
  line-height: 30px;
  letter-spacing: 2px;
  padding-top: 20px;
}
.center .line .item span {
  font-size: 30px;
  color: #5aa4da;
  letter-spacing: 0px;
  font-weight: bold;
}
.bottom {
  height: calc(100% - 360px);
  width: 98%;
  margin: 0 auto;
  display: inline-flex;
  margin-top: 10px;
}

.bottom-left-color-1 {
  color: #ff6666;
}
.bottom-left-color-2 {
  color: #ffca6c;
}
.bottom-left-color-3 {
  color: #468fb7;
}

.bottom-left-bg-1 {
  color: #ff6666;
  border: 1px solid #ff6666;
  background: #853c52;
}
.bottom-left-bg-2 {
  color: #ffca6c;
  border: 1px solid #ffca6c;
  background: #856e55;
}
.bottom-left-bg-3 {
  color: #43bcff;
  border: 1px solid #43bcff;
  background: #468fb7;
}

.bottom .left {
  width: 30%;
  height: 100%;
  background: #121d49;
  border-radius: 6px;
}
.bottom .left .item {
  clear: both;
  width: 92%;
  height: 32.33%;
  margin: 0 auto;
  margin-top: 1%;
}
.bottom .left .item .item-left {
  width: 40%;
  height: 100%;
  float: left;
  display: flex;
}

.bottom .left .item .item-left > div {
  width: 110px;
  height: 110px;
  border-radius: 4px;
  align-self: center;
  margin: 0 auto;
}

.bottom .left .item-left > div > ul > li:first-child {
  width: 100%;
  height: 20px;
  line-height: 20px;
  padding-top: 20px;
  font-size: 14px;
  text-indent: 16px;
  text-align: left;
  color: white;
}
.bottom .left .item-left > div > ul > li:last-child {
  width: 100%;
  height: 50px;
  line-height: 50px;
  font-size: 32px;
  text-align: center;
  color: white;
}

.bottom .left .item-right {
  width: 54%;
  height: 90%;
  float: right;
  margin: 2.5% 0 2.5% 6%;
  display: flex;
}

.bottom .left .item-right .item-right-box {
  width: 100%;
  height: 80%;
  align-self: center;
  margin: 0 auto;
}

.bottom .left .item-right-text {
  clear: both;
  width: 100%;
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  text-align: left;
  color: #a7c6d6;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.bottom .left .item-right-text > ul > li {
  float: left;
}

.bottom .left .item-right-text > ul > li > i {
  font-style: normal;
  display: inline;
  padding: 0px 1px 0px 1px;
}

.bottom .left .item-right .item-right-charts-info {
  width: 100%;
  height: calc(100% - 30px);
  height: -webkit-calc(100% - 30px);
  height: -moz-calc(100% - 30px);
}

.bottom .left .item-right .item-right-charts-info .item-right-charts {
  width: 66%;
  height: 100%;
  float: left;
}

.bottom .left .item-right .item-right-charts-info .item-right-charts .charts {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  float: left;
}

.bottom .left .item-right .item-right-charts-info .item-right-info {
  width: 34%;
  height: 20px;
  line-height: 20px;
  float: left;
  margin-top: 70px;
  font-size: 12px;
  color: #a7c6d6;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.item-right-info > ul > li {
  float: left;
}

.item-right-info > ul > li > i {
  font-style: normal;
}

.bottom .middle {
  width: calc(35% - 10px);
  width: -webkit-calc(35% - 10px);
  width: -moz-calc(35% - 10px);
  height: 100%;
  background: #121d49;
  border-radius: 6px;
  margin-left: 10px;
}
.bottom .middle .title {
  width: 100%;
  color: #88adc7;
  font-size: 24px;
  text-align: center;
  letter-spacing: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 4%;
}
.bottom .middle .sub-title {
  display: inline-flex;
  padding-top: 20px;
  width: 100%;
}
.bottom .middle .sub-title div {
  display: inline-flex;
  width: 33%;
}
.bottom .middle .sub-title div:first-child {
  margin-left: 0.5%;
}
.bottom .middle .sub-title span {
  color: #fff;
  font-size: 14px;
  line-height: 20px;
  width: 50%;
}
.bottom .middle .sub-title span:first-child {
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-height: 20px;
}
.bottom .middle .sub-title span:last-child {
  width: 50px;
  color: #fff;
  background: #ff6666;
  /*margin-right: 26px;*/
  margin-left: 6px;
  border-radius: 4px;
  float: right;
  max-height: 20px;
}
.bottom .middle .list {
  width: calc(100% - 20px);
  width: -webkit-calc(100% - 20px);
  width: -moz-calc(100% - 20px);
  margin: 0 auto;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
}
.bottom .middle .list .item {
  background: #202956;
  width: 99%;
  text-align: left;
  border-radius: 2px;
  height: 30px;
  line-height: 30px;
  color: #436ba9;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}
.bottom .middle .list .item label {
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-indent: 10px;
}
.bottom .middle .list .item div {
  display: inline-flex;
}
.bottom .middle .list .item div span {
  width: 40px;
  display: block;
  margin-right: 20px;
  border-radius: 6px;
  height: 18px;
  margin-top: 6px;
  line-height: 20px;
  text-align: center;
  font-weight: bold;
  color: #fff;
  font-size: 16px;
}
.out label {
  margin-right: 10px !important;
}
.out .in {
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/EchartsView2.vue